var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import { memo, useEffect, useState } from 'react';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { NotificationState, NotificationType } from 'root/src/shared/notification/notification.types';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import Markdown from 'react-markdown';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import remarkGfm from 'remark-gfm';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { MARKDOWN_COMPONENTS } from 'root/src/client/util/markdown';
const NotificationItem = memo((props) => {
    return (<div className="flex w-full flex-col gap-4">
			<div className="max-h-96 rounded overflow-scroll">
				<div className="py-4 px-4 rounded bg-dark-2">
					<Markdown remarkPlugins={[remarkGfm]} components={MARKDOWN_COMPONENTS}>
						{props.notification.content}
					</Markdown>
				</div>
			</div>
			<ButtonNew type="button" onClick={props.onClose}>
				{props.hasNext ? 'Next' : 'Close'}
			</ButtonNew>
		</div>);
});
const PopupNotificationsModal = memo((props) => {
    const modal = useModal();
    const readNotificationMutation = trpc.notification.read.useMutation();
    const [notificationIndex, setNotificationIndex] = useState(0);
    useEffect(() => {
        setNotificationIndex(0);
    }, [props.notifications]);
    const handleClose = (notification) => __awaiter(void 0, void 0, void 0, function* () {
        void readNotificationMutation.mutateAsync({
            notificationId: notification.id,
        });
        if (notificationIndex < props.notifications.length - 1) {
            setNotificationIndex(notificationIndex + 1);
            return;
        }
        modal.hide();
    });
    const notification = props.notifications[notificationIndex];
    if (!notification) {
        modal.hide();
        return null;
    }
    return (<ModalLayout className="sm:w-[620px] md:w-[700px]">
			<NotificationItem notification={notification} onClose={() => handleClose(notification)} hasNext={notificationIndex < props.notifications.length - 1}/>
		</ModalLayout>);
});
export const Notifications = memo(() => {
    const { authentication } = useAuthentication();
    const notificationsQuery = trpc.notification.list.useQuery({
        state: NotificationState.Unread,
        type: NotificationType.Popup,
    }, { enabled: Boolean(authentication) });
    const modal = useModal();
    const notifications = notificationsQuery.data || [];
    useEffect(() => {
        if (notifications.length) {
            modal.show(<PopupNotificationsModal notifications={notifications}/>, {
                isCloseable: false,
            });
        }
    }, [notifications]);
    return null;
});
